import { Box, Image } from "@chakra-ui/react";
import React from "react";

export default function Loading() {
  return (
    <Box
      w="100%"
      minH="300px"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Image h="50px" w="50px" src={require("../assets/img/spinner.gif")} />
    </Box>
  );
}
